export default "__VITE_PUBLIC_ASSET__bacf2ba2__"